import { generateUniqueId } from '../../helpers/common';

export const SEARCH_STATIONS_REQUEST = generateUniqueId();
export const SEARCH_STATIONS_SUCCESS = generateUniqueId();
export const SEARCH_STATIONS_FAILURE = generateUniqueId();

export const SELECT_STATION = generateUniqueId();
export const ADD_STATION_TO_SELECTIONS = generateUniqueId();
export const REMOVE_STATION_FROM_SELECTIONS = generateUniqueId();
export const CLEAR_SELECTIONS = generateUniqueId();

export const SELECT_FIELDS = generateUniqueId();
export const ADD_FIELDS_TO_SELECTIONS = generateUniqueId();
export const REMOVE_FIELDS_FROM_SELECTIONS = generateUniqueId();
export const CLEAR_FIELDS_SELECTIONS = generateUniqueId();

export const ADD_NEW_STATION = generateUniqueId();

export const CREATE_STATION_REQUEST = generateUniqueId();
export const CREATE_STATION_SUCCESS = generateUniqueId();
export const CREATE_STATION_FAILURE = generateUniqueId();

export const UPDATE_STATION_REQUEST = generateUniqueId();
export const UPDATE_STATION_SUCCESS = generateUniqueId();
export const UPDATE_STATION_FAILURE = generateUniqueId();

export const ARCHIVE_STATION_REQUEST = generateUniqueId();
export const ARCHIVE_STATION_SUCCESS = generateUniqueId();
export const ARCHIVE_STATION_FAILURE = generateUniqueId();

export const RESTORE_STATION_REQUEST = generateUniqueId();
export const RESTORE_STATION_SUCCESS = generateUniqueId();
export const RESTORE_STATION_FAILURE = generateUniqueId();

export const CHANGE_PAGINATION_PAGE = generateUniqueId();
export const CHANGE_PAGINATION_ROWS_PER_PAGE = generateUniqueId();

export const CHANGE_SEARCH_KEYWORD = generateUniqueId();
export const SET_STATION_NAME = generateUniqueId();
export const SET_STATUS = generateUniqueId();

export const SET_ID = generateUniqueId();
export const SET_NAME = generateUniqueId();
export const SET_PROJECT_NAME = generateUniqueId();

export const SET_REF_SLOW_DATA = generateUniqueId();
export const SET_REF_CAPACITY_DATA = generateUniqueId();
export const SET_REF_FAST_DATA = generateUniqueId();

export const SET_DESCRIPTION = generateUniqueId();
export const SET_STATION_CONFIG = generateUniqueId();
export const SET_LONGITUDE = generateUniqueId();
export const SET_LATITUDE = generateUniqueId();
export const SET_LOCATION = generateUniqueId();
export const SET_COUNTRY = generateUniqueId();
export const SET_CITY = generateUniqueId();
export const TOGGLE_DISABLED_CONFIRMATION = generateUniqueId();
export const TOGGLE_STATION_CONFIG_LIST_DIALOG = generateUniqueId();
export const SELECT_FIELD_NAME = generateUniqueId();
export const SELECT_AGG = generateUniqueId();
export const TOGGLE_ALERT_DIALOG = generateUniqueId();
export const OPEN_SNACK_BAR = generateUniqueId();
export const CLOSE_SNACK_BAR = generateUniqueId();

export const FETCH_GRAPH_REFERENCE_REQUEST = generateUniqueId();
export const FETCH_GRAPH_REFERENCE_SUCCESS = generateUniqueId();
export const FETCH_GRAPH_REFERENCE_FAILURE = generateUniqueId();
export const ADD_GRAPH_REFERENCE = generateUniqueId();
export const REMOVE_GRAPH_REFERENCE = generateUniqueId();

export const RESET_ACTION_STATUS = generateUniqueId();